/* eslint no-irregular-whitespace: "error" */

import React, { useEffect, useState, useCallback } from 'react'
import QRCode from 'react-qr-code'
import { Link } from 'react-router-dom'
import { androidApplicationId, androidFallbackUrl, androidMinimumVersion, dynamicLinkDomain, iOSApplicationId, iOSFallbackUrl, iOSMinimumVersion, apiEndpointBaseUrl, apiKey } from '@environments/environment'
import { RootState, Dispatcher } from 'AppTypes'
import { connect } from 'react-redux'
import * as actions from './state_management/actions'

const mapStateToProps = (state: RootState) => ({
  topVotes: state.vote.topVotes
})

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  getDataTopVote: () => dispatch(actions.getDataTopVote())
})

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

const Vote2022: React.FC<Props> = ({
  topVotes,
  getDataTopVote
}) => {
  const longLink = `${dynamicLinkDomain}/?link=${apiEndpointBaseUrl}share?act=votepage&apn=${androidApplicationId}&afl=${androidFallbackUrl}&amv=${androidMinimumVersion}&ibi=${iOSApplicationId}&ifl=${iOSFallbackUrl}&imv=${iOSMinimumVersion}`
  const [votePageLink, setVotePageLink] = useState(longLink)
  const getShortLink = useCallback(async () => {
    try {
      const data = {
        longDynamicLink: longLink
      }
      const response = await fetch(`https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${apiKey}`,
        {
          headers: {
            'Content-Type': 'application/json'
          },
          method: 'POST',
          body: JSON.stringify(data)
        })
      const res = await response.json()
      if (res && res.shortLink) {
        setVotePageLink(res.shortLink)
      }
    } catch (error) {
      console.error('error', error)
    }
  }, [longLink])

  useEffect(() => {
    getDataTopVote()
    getShortLink()
  }, [getDataTopVote, getShortLink])

  return (
    <div className="main-detail">
      <h2 className="title text-center justify-content-center mb-4">2022年度 GMTSアンバサダー推薦投票</h2>
      <div className="text-center text-vote"><span>次のGMTSアンバサダー候補を推薦お願いします！</span><span>GMTSでは、現在のNMB48メンバー５名（渋谷凪咲・上西怜・安部若菜・川上千尋・原かれん）に加えて、来年春にCMに出演するアンバサダーを新たに複数追加する予定です。</span></div>
      <img src="/assets/img/IMG_3512.png" alt="" />
      <div className="text-center mt-3 mb-3">皆様からご推薦いただいた上位者を参考に、新規アンバサダーを決定させていただきますので、ぜひご推薦ください。</div>
      <div className="jumbotron p-3 bg-white rounded text-vote"><span>※ 20歳以下の方はGMTSアンバサダーの対象にはなりませんので、投稿いただいても事務局で削除いたします。</span><span>※ 不適切な人物の推薦がなされた場合には、アカウントを停止・削除させていただきます。</span><span>※ 同一IDで推薦できるのは１回限りですが、応援動画投稿・承認で貯まるGMTSポイントやお友達紹介キャンペーンで付与されるGMTSポイントから、100GMTSポイント使用ごとに１回投票可能です。</span></div>
      <h2 className="title mt-5 justify-content-center mb-3">現在の人気上位</h2>
      <table className="table table-hover bg-white">
        <tbody>
          {
            topVotes && topVotes.length
              ? topVotes.map((val: any) =>
                (
                  <tr key={val.orderNumber}>
                    <td width={150}>{ val.orderNumber + 1 }位</td>
                    <td>{ val.ambassadorName }</td>
                    <td width={100} className="text-danger">{ val.countVoted }票</td>
                  </tr>
                ))
              : null
          }
        </tbody>
      </table>
      <div className="text-center w-100 mt-4 mb-3"><Link className="btn btn-lg btn-red" to={{ pathname: votePageLink }} target="_blank">アプリで投票</Link></div>
      <div className="text-center w-100 mt-4 mb-5 qr-code">
        <QRCode value={votePageLink} />
      </div>
    </div>

  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Vote2022)
